import { Link } from "react-router-dom";
import { ArrowRight, FileText, Video, BarChart3, BookOpen, Users, Calculator } from "lucide-react";
import SiteNav from "@/components/SiteNav";
import SiteFooter from "@/components/SiteFooter";

const RESOURCES = [
  { icon: FileText,   label: "Case Studies",           body: "Real-world programs, real intelligence outcomes." },
  { icon: BookOpen,   label: "White Papers",           body: "Research-grade thinking on the OS for athletes." },
  { icon: BarChart3,  label: "Research",               body: "Published + internal studies from our advisory network." },
  { icon: FileText,   label: "Blog",                   body: "Field notes from the front of the department." },
  { icon: Video,      label: "Webinars",               body: "Live sessions with founders + program directors." },
  { icon: Users,      label: "Customer Success",       body: "Programs that operationalized the platform end-to-end." },
  { icon: Calculator, label: "ROI Calculator",         body: "Model your program's ROI in minutes." },
  { icon: Video,      label: "Video Library",          body: "Onboarding, engine walk-throughs, integration guides." },
  { icon: FileText,   label: "Product Updates",        body: "What we shipped, what's next." },
];

export default function Resources() {
  return (
    <div className="min-h-screen bg-[#050810] text-white" data-testid="resources-page">
      <SiteNav />
      <section className="pt-32 pb-14 border-b border-white/8 max-w-7xl mx-auto px-6">
        <div className="text-[10px] tracking-[0.4em] uppercase font-bold text-fuchsia-300/80 mb-3">Resources</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.05]">
          Knowledge center.<br/>
          <span className="text-white/50">Everything you need to buy, build, and adopt.</span>
        </h1>
      </section>

      <section className="py-14 max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {RESOURCES.map((r) => (
          <div key={r.label} className="ink-card rounded-2xl p-6" data-testid={`resource-${r.label.toLowerCase().replace(/[^a-z]+/g,'-')}`}>
            <r.icon className="h-6 w-6 mb-3 text-white/70" />
            <div className="font-display font-black text-white text-lg">{r.label}</div>
            <div className="mt-2 text-sm text-white/65 leading-relaxed">{r.body}</div>
            <div className="mt-4 text-[10px] uppercase tracking-[0.25em] text-white/40">Coming soon</div>
          </div>
        ))}
      </section>

      <section className="py-16 border-t border-white/8 text-center">
        <h2 className="font-display font-black text-3xl text-white tracking-tight">Prefer a live walkthrough?</h2>
        <div className="mt-6">
          <Link to="/request-demo">
            <button className="text-white font-bold text-sm px-6 py-3 rounded-full inline-flex items-center gap-2"
              style={{ backgroundColor: "var(--brand-secondary)" }}>
              Request a demo <ArrowRight className="h-4 w-4" />
            </button>
          </Link>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
